module.exports = __webpack_public_path__ + "img/Cigna1-679b11f1-640w.cabddaac.png";